/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect, Switch } from 'react-router-dom'
import { connect, useDispatch, useSelector } from 'react-redux'
import { useMediaQuery } from '@offerzen/pinata'
import { useQuery } from 'react-query'

import CandidateProfileScene from './scenes/CandidateProfileScene'
import MobileAboutScene from './scenes/MobileAboutScene'
import MobileBlockedCompaniesScene from './scenes/MobileBlockedCompaniesScene'
import MobileCandidateProfileScene from './scenes/MobileCandidateProfileScene'
import MobileEducationScene from './scenes/MobileEducationScene'
import MobileEmploymentTypeScene from './scenes/MobileEmploymentTypeScene'
import MobileJobSearchScene from './scenes/MobileJobSearchScene'
import MobileNextJobScene from './scenes/MobileNextJobScene'
import MobileOnlineProfilesScene from './scenes/MobileOnlineProfilesScene'
import MobilePersonalInformationScene from './scenes/MobilePersonalInformationScene'
import MobileProjectsScene from './scenes/MobileProjectsScene'
import MobileRolesScene from './scenes/MobileRolesScene'
import MobileSkillsScene from './scenes/MobileSkillsScene'
import MobileUploadedFilesScene from './scenes/MobileUploadedFilesScene'
import MobileWorkHistoryScene from './scenes/MobileWorkHistoryScene'
import MobileWorkAuthorisationsScene from './scenes/MobileWorkAuthorisationsScene'
import MobileWorkplacePolicyScene from './scenes/MobileWorkplacePolicyScene'
import SkeletonMobileCandidateProfileScene from './skeletons/SkeletonMobileCandidateProfileScene'
import { fetchProfileSuccess } from './reducks/profile'
import { fetchProfile } from './apiModules/profile'
import { isCandidateProfileInitialised } from './selectors/profile'

import { useRedirectToOnboarding } from '../CandidateExperience/hooks'
import SkeletonCandidateProfileScene from './skeletons/SkeletonCandidateProfileScene'

const ProfileMain = ({ match, candidate }) => {
  const dispatch = useDispatch()
  useQuery(['candidateProfileREST', match.params.candidateSlug], () => fetchProfile(match.params.candidateSlug), {
    onSuccess: profile => {
      dispatch(fetchProfileSuccess(profile))
    },
  })
  const isProfileInitialised = useSelector(isCandidateProfileInitialised)

  useRedirectToOnboarding(candidate)
  const { isPhoneOrLarger } = useMediaQuery()
  return (
    <Choose>
      <When condition={isPhoneOrLarger}>
        <Switch>
          <Redirect from={`${match.path}/:mobileSection`} to={match.path} />
          <Choose>
            <When condition={!isProfileInitialised}>
              <SkeletonCandidateProfileScene />
            </When>
            <Otherwise>
              <Route path={match.path} component={CandidateProfileScene} />
            </Otherwise>
          </Choose>
        </Switch>
      </When>

      <Otherwise>
        <Switch>
          <Choose>
            <When condition={!isProfileInitialised}>
              <SkeletonMobileCandidateProfileScene />
            </When>
            <Otherwise>
              <Route path={`${match.path}/job-search`} component={MobileJobSearchScene} />
              <Route path={`${match.path}/personal-information`} component={MobilePersonalInformationScene} />
              <Route path={`${match.path}/preferred-salary`} component={MobileEmploymentTypeScene} />
              <Route path={`${match.path}/ideal-job`} component={MobileNextJobScene} />
              <Route path={`${match.path}/work-authorisation`} component={MobileWorkAuthorisationsScene} />
              <Route path={`${match.path}/workplace-policy`} component={MobileWorkplacePolicyScene} />
              <Route path={`${match.path}/online-profiles`} component={MobileOnlineProfilesScene} />
              <Route path={`${match.path}/preferred-roles`} component={MobileRolesScene} />
              <Route path={`${match.path}/top-skills`} component={MobileSkillsScene} />
              <Route path={`${match.path}/work-history`} component={MobileWorkHistoryScene} />
              <Route path={`${match.path}/education`} component={MobileEducationScene} />
              <Route path={`${match.path}/about-me`} component={MobileAboutScene} />
              <Route path={`${match.path}/projects`} component={MobileProjectsScene} />
              <Route path={`${match.path}/uploaded-files`} component={MobileUploadedFilesScene} />
              <Route path={`${match.path}/blocked-companies`} component={MobileBlockedCompaniesScene} />
              <Route path={match.path} component={MobileCandidateProfileScene} />
            </Otherwise>
          </Choose>
        </Switch>
      </Otherwise>
    </Choose>
  )
}

ProfileMain.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  candidate: PropTypes.shape({}),
}

const mapStateToProps = state => ({
  candidate: state.candidate,
})

export default connect(mapStateToProps)(ProfileMain)
